'use strict';

import * as progress from './progress';
import modules from '../helpers/modules';
import {initMethods, setOverlay, unsetOverlay} from '../helpers/utilities';
import {disableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';
import {callbackOnElements} from '@borngroup/born-utilities';
import * as applepayapi from '../applepayapi';

let minicartTrigger,
    minicartDropdown;

function _renderMinicartDropdown(response) {
    progress.hideLoader();

    let restrictSiteAccessForLoggedInUser = window.SFRA.SitePreferences.restrictSiteAccessForLoggedInUser,
        isCustomerLoggedIn = window.SFRA.sessionData.loggedin;

    if (restrictSiteAccessForLoggedInUser && !isCustomerLoggedIn) {
        window.location.href = window.SFRA.Urls.loginShow;
    } else {
        minicartDropdown.textContent = '';
        minicartDropdown.innerHTML = response;
        applepayapi.init();

        import(/* webpackChunkName: "module-line-item" */ '../cart/lineItem').then(function(LineItem) {
            initMethods(modules, minicartDropdown);
            LineItem.init(minicartDropdown);

            minicartDropdown.classList.add('set--loaded');
            disableBodyScroll(minicartDropdown.querySelector('[data-minicart-component="items"]'));

            $('body').trigger('miniCart:afterLoad', {
                container: minicartDropdown,
                response: response
            });
        });
    }
}

function _handleMinicartLoad(currentTrigger) {
    let url = currentTrigger.getAttribute('data-action-url');

    setOverlay({trigger: currentTrigger, includeHeader: true});

    progress.showLoader(minicartDropdown);

    $('body').trigger('miniCart:beforeLoad');

    $.get(url, _renderMinicartDropdown);

    return true;
}

function handleFocusTrap() {
    let firstFocusableElement = minicartDropdown.querySelector('[data-minicart-component="qty"]'),
        lastFocusableElement = minicartDropdown.querySelector('[data-cart-component="checkout-action"]'),
        applePayButton = minicartDropdown.querySelector('[data-applepay-instant-checkout="button"]');
    minicartDropdown.addEventListener('keydown', function(e) {
        let isTabPressed = (e.key === 'Tab' || e.keyCode === 9);
        if (!isTabPressed) {
            return;
        }

        if (isTabPressed) {
            if (document.activeElement === lastFocusableElement && applePayButton && !$(applePayButton).is(':visible')) {
                e.preventDefault();
                firstFocusableElement.focus();
            }
        }
    })
}

if (document.querySelector('[data-minicart-component="trigger"]') != null) {
    document.querySelector('[data-minicart-component="trigger"]').addEventListener('mouseenter', function() {
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
            return false;
        } else {
            minicartTrigger.toggle.set();
        }
    });

    document.querySelector('[data-minicart-component="trigger"]').addEventListener('keydown', function(e) {
        let keyPressed = (e.keyCode == 13);
        if (keyPressed) {
            minicartTrigger.toggle.afterSet = function() {
                setTimeout(function() {
                    let firstElement = minicartDropdown.querySelector('.utility-overlay__header-anchor');
                    if (firstElement) {
                        firstElement.focus();
                        handleFocusTrap();
                    }
                }, 2000);
            }
        }
    })
}

if (document.querySelector('[data-minicart-component="overlay"]') != null) {
    document.querySelector('[data-minicart-component="overlay"]').addEventListener('mouseenter', function() {
        $('[data-minicart-component="overlay"]').on('mouseleave', function(evt) {
            if (evt.relatedTarget != null && !evt.relatedTarget.classList.contains('product-add__button') && minicartTrigger.getAttribute('aria-expanded')) {
                minicartTrigger.toggle.unset();
                $('[data-minicart-component="overlay"]').off('mouseleave');
            }
        });
    });
}

export function updateMinicartCount(qtyTotal) {
    if (!isNaN(qtyTotal)) {
        let minicartContainerEl = document.querySelector('[data-minicart-component="container"]'),
            minicartTriggerDescription = (qtyTotal === 1 ? window.SFRA.Resources.cartCountLabel : window.SFRA.Resources.cartCountLabelPlural).format(qtyTotal);

        //Update minicart trigger's labels
        callbackOnElements('[data-minicart-component="qty"]', function(currentEl) {
            if (currentEl.hasAttribute('data-qty-label-single') && qtyTotal === 1) {
                currentEl.textContent = currentEl.getAttribute('data-qty-label-single').format(qtyTotal);
            } else if (currentEl.hasAttribute('data-qty-label')) {
                currentEl.textContent = currentEl.getAttribute('data-qty-label').format(qtyTotal);
            } else {
                currentEl.textContent = qtyTotal;
            }
        });

        if (minicartTrigger) {
            minicartTrigger.setAttribute('aria-label', minicartTriggerDescription);
            minicartTrigger.setAttribute('title', minicartTriggerDescription);
        }

        if (qtyTotal > 0) {
            minicartContainerEl.classList.add('set--has-items');
        } else {
            minicartContainerEl.classList.remove('set--has-items');
        }
    }
}

/**
 * Opens minicart.
 * @return {[type]} [description]
 */
export function openMinicart() {
    if (minicartTrigger && minicartTrigger.toggle) {
        minicartTrigger.toggle.set();
        if ($('.search-results').length > 0) {
            $('.strap-bar__dailog').removeClass('opacity');
            $('.product-tile').removeClass('index strap-view-active');
            $('.window-overlay').removeClass('strap-overlay');
            $('.search-results__toolbar').removeClass('index');
            document.body.classList.remove('strap-dialog-overlay');
        }

        //***If using a transform property, uncomment these lines:***
        //Wait until full navigation is visible before opening minicart.
        //This prevents some odd animations from the minicart transition-in.
        // if (!headerEl.classList.contains('fixit--scrolled') || headerEl.classList.contains('fixit--scroll-up')) {
        //     minicartTrigger.toggle.set();
        // } else {
        //     headerEl.addEventListener(whichTransition(), function waitForHeaderMotion(evt) {
        //         if (evt.propertyName === 'margin-top') {
        //             minicartTrigger.toggle.set();

        //             this.removeEventListener(whichTransition(), waitForHeaderMotion);
        //         }
        //     });

        //     publishEvent('fixit', 'updateScrollDirection', headerEl, {scrollDirection: 'up'});
        // }
    }
}

/**
 * I think this closes minicart?
 * @return {[type]} [description]
 */
export function closeMinicart() {
    if (minicartTrigger && minicartTrigger.toggle) {
        minicartTrigger.toggle.unset();
    }
}

export const init = {

    setupMiniCart: function() {
        minicartTrigger = document.querySelector('[data-minicart-component="trigger"]');
        minicartDropdown = document.querySelector('[data-minicart-component="overlay"]');
        if (minicartTrigger && minicartTrigger.toggle) {
            minicartTrigger.toggle.beforeSet = _handleMinicartLoad;
            minicartTrigger.toggle.afterUnset = function() {
                clearAllBodyScrollLocks();
                unsetOverlay({trigger: minicartTrigger, includeHeader: true});
                $('body').trigger('miniCart:afterUnLoad');
            };
        }
    }
};
